export default __webpack_public_path__ + "static/media/chapter6.55eb40b8.png";